module.exports = __webpack_public_path__ + "static/x86-products.7e4377b3.png";